(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Subcategory', Subcategory);

    Subcategory.$inject = ['$resource', 'DateUtils'];

    function Subcategory ($resource, DateUtils) {
        var resourceUrl =  'api/subcategories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.updatedAt = DateUtils.convertDateTimeFromServer(data.updatedAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
